<template>
    <section class="w-full py-12 md:py-24 lg:py-32 bg-white flex items-center justify-center">
          <div class="container px-0 md:px-6">
            <div class="text-center mb-12">
              <h2 class="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl mb-4 text-[#131211] font-modulus-semi-bold">
                {{ $t('messages.company_info_title') }}
              </h2>
              <p class="mx-auto max-w-[700px] text-gray-600 md:text-xl font-modulus">
                {{ $t('messages.company_info_subtitle') }}
              </p>
            </div>
            <div class="max-w-4xl mx-auto">
              <div class="w-full space-y-4">
                <accordion-item
                v-for="value in accordionsItems"
                :key="value.title"
                :svg="value.svg"
                :title="value.title"
                :content="value.content"
                ></accordion-item>
              </div>
            </div>
          </div>
        </section>
</template>

<script>
    import AccordionItem from './AccordionItem.vue';
    export default {
        name: 'CompanyInformationSection',
        computed: {
            accordionsItems() {
                return [
                    {
                        title: this.$t('messages.what_is_emanta_title'),
                        content: this.$t('messages.what_is_emanta_content'),
                        svg: `<svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="h-5 w-5 text-[#FF8A4C]"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" /><path d="M3.6 9h16.8" /><path d="M3.6 15h16.8" /><path d="M11.5 3a17 17 0 0 0 0 18" /><path d="M12.5 3a17 17 0 0 1 0 18" /></svg>`
                    },
                    {
                        title: this.$t('messages.how_platform_works_title'),
                        content: this.$t('messages.how_platform_works_content'),
                        svg: `
                        <svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="h-5 w-5 text-[#FF8A4C]"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" /><path d="M12 9h.01" /><path d="M11 12h1v4h1" /></svg>`
                    },
                    {
                        title: this.$t('messages.cancellation_policy_title'),
                        content: this.$t('messages.cancellation_policy_content'),
                        svg: `
                        <svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="h-5 w-5 text-[#FF8A4C]"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M14 3v4a1 1 0 0 0 1 1h4" /><path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z" /><path d="M9 7l1 0" /><path d="M9 13l6 0" /><path d="M13 17l2 0" /></svg>`
                    },
                    {
                        title: this.$t('messages.security_privacy_title'),
                        content: this.$t('messages.security_privacy_content'),
                        svg: `
                        <svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="h-5 w-5 text-[#FF8A4C]"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3" /><path d="M12 11m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" /><path d="M12 12l0 2.5" /></svg>`
                    },
                    {
                        title: this.$t('messages.customer_support_title'),
                        content: this.$t('messages.customer_support_content'),
                        svg: `
                        <svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="h-5 w-5 text-[#FF8A4C]"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 14v-3a8 8 0 1 1 16 0v3" /><path d="M18 19c0 1.657 -2.686 3 -6 3" /><path d="M4 14a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-1a2 2 0 0 1 -2 -2v-3z" /><path d="M15 14a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-1a2 2 0 0 1 -2 -2v-3z" /></svg>`
                    },
                    {
                        title: this.$t('messages.global_coverage_title'),
                        content: this.$t('messages.global_coverage_content'),
                        svg: `<svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="h-5 w-5 text-[#FF8A4C]"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" /><path d="M3.6 9h16.8" /><path d="M3.6 15h16.8" /><path d="M11.5 3a17 17 0 0 0 0 18" /><path d="M12.5 3a17 17 0 0 1 0 18" /></svg>`
                    }
                ]
            }
        },
        components: {
            AccordionItem
        }
    }
</script>

<style lang="scss" scoped>

</style>